export default __webpack_public_path__ + "static/media/invite-bg.fa8f5c53.png";